import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import CTypography from "../../../componets/typography";
import { NavigationStyled } from "./navigation-styled";
import { CustomCursorContext } from "../../../contexts/cursor";
import { NAVIGATION_ITEMS } from "../../../constants";

export const Navigation = ({ executeScroll }) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const { setType } = useContext(CustomCursorContext);
  const navigate = useNavigate();

  const navigationItemsDisplay = NAVIGATION_ITEMS?.map?.(({ name, route }) => {
    return (
      <CTypography
        color="var(--River-bed)"
        size="small"
        weight="bold"
        className="nav-items"
        key={name}
        id={name}
        onClick={() => (route ? navigate(route) : executeScroll({ name: name }))}
        onMouseEnter={(e) => {
          setHoveredItem(e.target.id);
          setType("hover");
        }}
        onMouseLeave={(e) => {
          setHoveredItem(null);
          setType("");
        }}
      >
        {name}
      </CTypography>
    );
  });
  return (
    <NavigationStyled hoveredItem={hoveredItem}>
      {navigationItemsDisplay}
    </NavigationStyled>
  );
};
